var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    staticStyle: {
      "margin-bottom": "4px",
      width: "100%"
    },
    attrs: {
      layout: "inline"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品类型")
    }
  }, [_c("div", {
    staticClass: "btns",
    class: _vm.current == 1 ? "left" : "",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.current == 0 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("主险")))]), _vm.isAuth("home.insuranceAttachList") ? _c("div", {
    staticClass: "btn",
    class: _vm.current == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("附加险")) + " ")]) : _vm._e()])])], 1), _vm.current == 0 ? _c("main-list") : _vm._e(), _vm.current == 1 ? _c("additional-list") : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };